import { render } from "./BundleCreateModal.vue?vue&type=template&id=6ad5014a&ts=true"
import script from "./BundleCreateModal.vue?vue&type=script&lang=ts"
export * from "./BundleCreateModal.vue?vue&type=script&lang=ts"

import exportComponent from "/var/www/rewards/runners/admin/root/reward-admin/reward-admin/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__